"use strict";

var _classCallCheck = require("/opt/build/repo/.yarn/cache/@babel-runtime-npm-7.15.4-52ce5bf6ea-c408254304.zip/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/.yarn/cache/@babel-runtime-npm-7.15.4-52ce5bf6ea-c408254304.zip/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Draw = void 0;

var DrawStroke_1 = require("./DrawStroke");

var OptionsColor_1 = require("../../../../Options/Classes/OptionsColor");

var Draw = /*#__PURE__*/function () {
  function Draw() {
    _classCallCheck(this, Draw);

    this.enable = false;
    this.stroke = new DrawStroke_1.DrawStroke();
  }

  _createClass(Draw, [{
    key: "lineWidth",
    get: function get() {
      return this.stroke.width;
    },
    set: function set(value) {
      this.stroke.width = value;
    }
  }, {
    key: "lineColor",
    get: function get() {
      return this.stroke.color;
    },
    set: function set(value) {
      this.stroke.color = OptionsColor_1.OptionsColor.create(this.stroke.color, value);
    }
  }, {
    key: "load",
    value: function load(data) {
      var _a;

      if (data !== undefined) {
        if (data.enable !== undefined) {
          this.enable = data.enable;
        }

        var stroke = (_a = data.stroke) !== null && _a !== void 0 ? _a : {
          color: data.lineColor,
          width: data.lineWidth
        };
        this.stroke.load(stroke);
      }
    }
  }]);

  return Draw;
}();

exports.Draw = Draw;